import { Link, useLocation } from 'react-router-dom';
import { Home, UtensilsCrossed, ClipboardList, Receipt } from 'lucide-react';
import { cn } from '@kss/ui';
import { useTablePaths } from './useTablePaths';

/** App-style fixed bottom navigation: Home · Menu · Orders · Pay bill.
 *  Menu/Orders/Bill target the CURRENT table (encrypted token), not a hardcoded table. */
export function BottomNav() {
  const { pathname } = useLocation();
  const paths = useTablePaths();
  const items = [
    { label: 'Home', to: '/', Icon: Home, match: (p: string) => p === '/' },
    { label: 'Menu', to: paths.menu, Icon: UtensilsCrossed, match: (p: string) => p.startsWith('/t/') && !p.includes('/track') && !p.includes('/bill') },
    { label: 'Orders', to: paths.track, Icon: ClipboardList, match: (p: string) => p.includes('/track') },
    { label: 'Pay bill', to: paths.bill, Icon: Receipt, match: (p: string) => p.includes('/bill') }
  ];
  return (
    <nav className='fixed inset-x-0 bottom-0 z-30 border-t border-border bg-surface-topbar'>
      <div className='mx-auto flex max-w-[1160px]'>
        {items.map(({ label, to, Icon, match }) => {
          const active = match(pathname);
          return (
            <Link
              key={label}
              to={to}
              className={cn(
                'flex flex-1 flex-col items-center gap-0.5 py-2.5 text-[11px] font-semibold transition-colors',
                active ? 'text-primary' : 'text-content-secondary hover:text-content-primary'
              )}
            >
              <Icon size={20} />
              {label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
